import React, { ReactElement } from 'react'
import _ from 'lodash'
import { Checkbox, Radio } from 'react-bootstrap'
import FormGroup from 'live/components/forms/ui/form-group'
import Select from 'react-select'
import i18n from 'live/services/i18n'
import { FormEnabledContext } from 'live/context/form-enabled'
import LiveTooltip from 'live/components/ui/tooltip'
import ActionToggle from 'live/components/ui/action-toggle'

type SpanItemProps = {
    name: string
    onChange: Function
    value: string
    data: Record<string, unknown>
    hasError: boolean
}
class TableFormSpanComponent extends React.Component<SpanItemProps> {
    onChange(e) {
        this.props.onChange(e.target.name, e.target.value)
    }

    onChangeDashboardCategory(e) {
        if (!e.target.value || e.target.value.length === 0) {
            this.props.onChange(e.target.name, this.getDashboardCategory())
        } else {
            this.props.onChange(e.target.name, e.target.value)
        }
    }

    getDashboardCategory() {
        return this.props.data.spanType + ' Dashboards'
    }

    render() {
        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ flexGrow: 1, margin: '5px', width: '10%', paddingTop: '5px' }}>
                        <span style={{ paddingRight: '5px' }}>Depth</span>
                        <ActionToggle
                            onChange={() => {
                                this.onChange({
                                    target: {
                                        name: 'spanType',
                                        value: this.props.data.spanType === 'Time' ? 'Depth' : 'Time'
                                    }
                                })
                            }}
                            active={!this.props.data || this.props.data.spanType === 'Time'}
                            disabled={false}
                        />
                        <span>Time</span>
                    </div>
                    <div style={{ flexGrow: 1, margin: '5px', width: '35%' }}>
                        <FormGroup
                            type={'text'}
                            placeholder={'Dashboard Name'}
                            value={this.props.data && this.props.data.dashboard ? this.props.data.dashboard : ''}
                            name={'dashboard'}
                            onChange={e => this.onChange(e)}
                        />
                    </div>

                    <div
                        style={{
                            flexGrow: 1,
                            marginLeft: '5px',
                            marginTop: this.props.data.showActiveOverrideFunction ? '-8px' : '5px',
                            width: this.props.data.showActiveOverrideFunction ? '17%' : 'auto'
                        }}
                    >
                        <Checkbox
                            checked={this.props.data?.overridePreset || false}
                            value={this.props.data?.overridePreset || false}
                            onChange={({ target }) => {
                                this.onChange({
                                    target: {
                                        name: 'overridePreset',
                                        value: target.checked
                                    }
                                })
                            }}
                        >
                            <span style={{ top: '7px', position: 'relative' }}>{i18n('Override Span Preset')}</span>
                        </Checkbox>
                        {this.props.data.showActiveOverrideFunction && (
                            <Checkbox
                                checked={this.props.data?.showAllDataIfCompleted || false}
                                value={this.props.data?.showAllDataIfCompleted || false}
                                onChange={({ target }) => {
                                    this.onChange({
                                        target: {
                                            name: 'showAllDataIfCompleted',
                                            value: target.checked
                                        }
                                    })
                                }}
                            >
                                <span style={{ top: '7px', position: 'relative' }}>
                                    {i18n('Show all data if completed')}
                                </span>
                            </Checkbox>
                        )}
                    </div>
                    <div style={{ flexGrow: 1, margin: '5px' }}>
                        <FormGroup
                            type={'text'}
                            name={'spanPresetValue'}
                            placeholder={'Span Preset (Auto)'}
                            value={
                                !this.props.data
                                    ? ''
                                    : this.props.data.overridePreset
                                    ? this.props.data.spanPresetValue
                                    : this.props.data.spanType === 'Time'
                                    ? this.props.data.timeSpanPreset
                                    : this.props.data.depthSpanPreset
                            }
                            onChange={e => this.onChange(e)}
                            disabled={!this.props.data || !this.props.data.overridePreset}
                        />
                    </div>
                    <div style={{ flexGrow: 1, margin: '5px' }}>
                        <FormGroup
                            type={'text'}
                            name={'spanPresetAnchor'}
                            placeholder={
                                this.props.data.spanType === 'Time' ? 'Preset Anchor Time' : 'No Depth Anchoring'
                            }
                            value={
                                !this.props.data
                                    ? ''
                                    : this.props.data.overridePreset && this.props.data.spanType === 'Time'
                                    ? this.props.data.spanPresetAnchor
                                    : ''
                            }
                            onChange={e => this.onChange(e)}
                            disabled={
                                !this.props.data ||
                                !this.props.data.overridePreset ||
                                !(this.props.data.spanType === 'Time')
                            }
                        />
                    </div>
                    <div style={{ flexGrow: 1, margin: '3px', width: '15%' }}>
                        <Select
                            menuPortalTarget={document.body}
                            placeholder={'Select dashboard Category'}
                            value={this.props.data?.dashboardCategory}
                            className="Select-small"
                            options={this.props.data?.dashboardCategoriesList}
                            onChange={e =>
                                this.onChange({
                                    target: {
                                        name: 'dashboardCategory',
                                        value: e.value
                                    }
                                })
                            }
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default TableFormSpanComponent
